import React from 'react'
import { Box } from 'ui/acro'
import Text from 'ui/acro/typography/Text'
import {
  PageLayout,
  PageHeader,
  BreadcrumbBar,
  ArticleList
} from '../__shared__'
import { getCategoriesDisplay } from '../constants'

const CategoryView = ({ articleList, category }) => {
  const categoryDisplayName = getCategoriesDisplay(category)
  return (
    <>
      <Box
        py={[null, '30px', '30px']}
        display={['none', 'block', 'block']}
        backgroundColor='#FAFAFA'
      >
        <PageHeader title='FAQ Topics' />
      </Box>
      <PageLayout>
        <BreadcrumbBar
          categoryName={category}
          categoryDisplayName={categoryDisplayName}
        />
        <Text
          as={'h2'}
          fontFamily='Arquitecta'
          fontSize={['24px', '37px']}
          fontStyle='normal'
          fontWeight='900'
          lineHeight='40px'
          pt={['25px', '46px']}
          pb={'10px'}
          letterSpacing='0.07em'
          textAlign='left'
          textTransform='uppercase'
        >
          {categoryDisplayName}
        </Text>
        <ArticleList articleList={articleList} category={category} />
      </PageLayout>
    </>
  )
}

export default CategoryView
